// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"457":"c0b82683","787":"4fd2a77c"}[chunkId] + ".chunk.js";
};